module.exports = __webpack_public_path__ + "6d325f79262b9726d3335437d904bbeb.png";